import { http } from "@/utils/http";

// 新建&&编辑设施
const editMarkerAPI = (options = {}) => {
  return http({
    url: "/api-customer/location/facility",
    method: options.method,
    data: options.data
  });
};

// 移动端查询基础设施列表
const getFacilitiesAPI = (options = {}) => {
  return http({
    url: "/api-customer/location/facilities",
    method: "get",
    data: options.data
  });
};
// 根据Id删除市政设施
const deleteFacilityAPI = options => {
  console.log(options);
  return http({
    url: `/api-customer/location/facility/${options.id}`,
    method: "delete"
  });
};

// 获取设施配置
const getFacilityTypeAPI = (options = {}) => {
  return http({
    url: "/api-customer/location/facility/types",
    method: "get",
    data: options.data
  });
};

// 根据每种设施的数量

const getFacilitiesCountAPI = (options = {}) => {
  return http({
    url: "/api-customer/location/facilitiesCount",
    method: "get",
    data: options.data
  });
};

// 获取组织结构
const getAllOrgAPI = (options = {}) => {
  return http({
    url: "/api-customer/organization/queryOwnOrganization",
    method: "get",
    data: options.data
  });
};

// 图片上传
const uploadImgAPI = data => {
  return http({
    url: "/api-customer/zuul/dig-construction/uploadFile",
    method: "post",
    data
  });
};

// 根据类型查询设施的地理区域
const getGpsAreasByTypeAPI = (options={}) => {
  return http({
    url: `/api-customer/location/facilities/type/${options.data.type}/gpsAreas`,
    method: "get",
    data: options.data
  });
};

// 根据类型查询设施的地理区域
const queryNearbyLabelsAPI = (options={}) => {
  return http({
    url: `/api-customer/location/queryNearbyLabels`,
    method: "post",
    data: options.data
  });
};

const queryEmployeesByOrgIdAPI = (options={})=>{
  return http({
    url:`/api-customer/entity/queryEmployeesByOrgId`,
    method:'get',
    data:options.data
  })
}

const querySanitationReportByEmployeeIdAPI=(options={})=>{
  return http({
    url:`/api-customer/querySanitationReportByEmployeeId`,
    method:'get',
    data:options.data
  })
} 
export {
  editMarkerAPI,
  getFacilitiesAPI,
  deleteFacilityAPI,
  getFacilitiesCountAPI,
  getFacilityTypeAPI,
  getAllOrgAPI,
  uploadImgAPI,
  getGpsAreasByTypeAPI,
  queryNearbyLabelsAPI,
  queryEmployeesByOrgIdAPI,
  querySanitationReportByEmployeeIdAPI
};



// WEBPACK FOOTER //
// ./src/api/facility.js